import BaseService from "./BaseService";

export default class FeeService extends BaseService {
    public static getUserLimitHistory(token: string, postData: any, USER_ID: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}payment/user-limit-history/${USER_ID}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getUserReports(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}payment/user-metrics`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }
}
